import React from 'react';

import Hexagon from '../../Img/Hexagon'
import Animated from './hexagonPoses';

class ControlState extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      enable: false
    };
  }

  toExchange = () => {
    if(this.props.animation_enable){
      this.setState({ enable: !this.state.enable });
    } else {
      this.setState({ enable: false });
    }
  };

  start = () => {
    setTimeout(this.toExchange, 0);

    if(this.props.looping){
      this.interval = setInterval(this.toExchange, this.props.interval_timer);
    }
  }

  componentDidMount() {
    setTimeout(this.start, this.props.interval_timer * this.props.delay_timer);
  }

  render() {
    const state = this.state;
    const props = this.props;
    return (
      <Animated
        pose={state.enable ? 'enable' : 'disable'}
        poseProps={props}
      >
        {props.children}
      </Animated>
    );
  };
};

export const UnityHexagon = (props) => {
  return (
    <ControlState
      {...props}
    >
      <Hexagon
        {...props}
      />
    </ControlState>
  );
};

export default UnityHexagon;



// WEBPACK FOOTER //
// ./src/components/UI/Animations/HeroHexagons/index.jsx